module.exports = __webpack_public_path__ + "img/vk.54ed5c0a.svg";